import { Button } from "../Button";
import { TablePagingProps } from "./interfaces";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useTranslation } from "../../hooks/i18n";
import { useStyles } from "./styles";

export const TablePaging: React.FC<TablePagingProps> = ({
  onNext,
  onPrev,
  showNext,
  showPrev,
  loading,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      {showPrev && (
        <Button
          aria-label="previous_page"
          onClick={onPrev}
          disabled={loading}
          variant="text"
          startIcon={<ChevronLeftIcon />}
        >
          {t("previous_n_events", { count: 25 })}
        </Button>
      )}

      {showNext && (
        <Button
          aria-label="next_page"
          onClick={onNext}
          disabled={loading}
          variant="text"
          endIcon={<ChevronRightIcon />}
        >
          {t("next_n_events", { count: 25 })}
        </Button>
      )}
    </div>
  );
};
